// removed by extract-text-webpack-plugin
module.exports = {"lecture-editor":"w3vvay_r4eu5cLqlViGbO","rdw-editor-main":"_3szn0svJuhJnFmn74-bfNZ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LecturePage/lecture-brief-editor.scss
// module id = 1292
// module chunks = 0